import { render, staticRenderFns } from "./SelectedNpsunitBox.vue?vue&type=template&id=6d1fa50e&"
import script from "./SelectedNpsunitBox.vue?vue&type=script&lang=js&"
export * from "./SelectedNpsunitBox.vue?vue&type=script&lang=js&"
import style0 from "./SelectedNpsunitBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports